import AccessControlErrors from './accessControl';
import AccountErrors from './account';
import AccountSetupErrors from './accountSetup';
import AdminErrors from './admin';
import AgentErrors from './agent';
import BankingErrors from './banking';
import BillingErrors from './billing';
import CardErrors from './card';
import ContractErrors from './contract';
import ExternalAccessErrors from './externalAccess';
import GeneralErrors from './general';
import IcatuCapErrors from './icatuCap';
import InsuranceErrors from './insurance';
import KycErrors from './kyc';
import LandlordAreaErrors from './landlordArea';
import ListingErrors from './listing';
import PinErrors from './pin';
import PointErrors from './point';
import RateLimitErrors from './rateLimit';
import RecaptchaErrors from './recaptcha';
import ReferralErrors from './referral';
import RentalErrors from './rental';
import ReportErrors from './report';
import ResourceVerificationErrors from './resourceVerification';
import ScreeningErrors from './screening';
import StakeholderErrors from './stakeholder';
import SubscriptionErrors from './subscription';
import WorkspaceErrors from './workspace';
import ZipcodeErrors from './zipcode';

import { BackendError } from './base';

const errors = {
    ...AccessControlErrors,
    ...AccountErrors,
    ...AccountSetupErrors,
    ...AdminErrors,
    ...AgentErrors,
    ...BankingErrors,
    ...BillingErrors,
    ...CardErrors,
    ...ContractErrors,
    ...ExternalAccessErrors,
    ...GeneralErrors,
    ...IcatuCapErrors,
    ...InsuranceErrors,
    ...KycErrors,
    ...LandlordAreaErrors,
    ...ListingErrors,
    ...PinErrors,
    ...PointErrors,
    ...RateLimitErrors,
    ...RecaptchaErrors,
    ...ReferralErrors,
    ...RentalErrors,
    ...ReportErrors,
    ...ResourceVerificationErrors,
    ...ScreeningErrors,
    ...StakeholderErrors,
    ...SubscriptionErrors,
    ...WorkspaceErrors,
    ...ZipcodeErrors,
    BackendError,
};

export {
    errors,
    AccessControlErrors,
    AccountErrors,
    AccountSetupErrors,
    AdminErrors,
    AgentErrors,
    CardErrors,
    ContractErrors,
    GeneralErrors,
    IcatuCapErrors,
    InsuranceErrors,
    KycErrors,
    LandlordAreaErrors,
    ListingErrors,
    PinErrors,
    PointErrors,
    RateLimitErrors,
    RecaptchaErrors,
    ReferralErrors,
    ReportErrors,
    ResourceVerificationErrors,
    ScreeningErrors,
    StakeholderErrors,
    SubscriptionErrors,
    ZipcodeErrors,
    BackendError,
};
